<template>
    <button
        type="button"
        class="btn btn-default exportbtn"
        @click="exportPdf"
    >
        <span class="fas fa-file-pdf"></span> Export PDF
    </button>
</template>

<style scoped>
    .btn-area .exportbtn {
        position: relative;
        float: right;
    }

    .btn{
        position: absolute;
        left: 12px;
        top: 14px;
        font-size: 14px;
        color: red;
    }

    .fa-file-pdf {
        font-size: 16px;
        color: red;
    }

    
    @media only screen and (max-width: 600px) {
        .exportbtn {
            float: none;
        }
        .btn {
            position: absolute;
            left: 14px;
            top: 14px;
            font-size: 12px;
            color: red;
        }

        .btn {
            font-size: 14px;
            padding: 6px;
        }
    }

</style>